import SimpleMdeEditorsContainer from "../../Componant/Editors/SimpleMdeEditors";

const SimpleMdeEditors = () => {
  return (
    <div className="page-body">
      <SimpleMdeEditorsContainer />
    </div>
  );
};

export default SimpleMdeEditors;
